import axios from './axios';
import config from '../../helpers/config';

export default (designId) => {
  let url = `${config.designBuilderApiBaseUrl}${config.designBuilderBuyDesignPath}`;
  url = url.replace('<guid>', designId);

  return axios.get(url);
};
